import { render, staticRenderFns } from "./convocationPending.vue?vue&type=template&id=3f9e5222"
import script from "./convocationPending.vue?vue&type=script&lang=js"
export * from "./convocationPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports